import type { JiraSoftwareNavData } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/project-sidebar-navigation/types.tsx';
import type { Features } from '@atlassian/jira-navigation-apps-sidebar-next-gen-use-features/src/types.tsx';
import type { NextgenSidebarSettings } from './types.tsx';

export const extractData = (
	navData: JiraSoftwareNavData,
	features: Features,
	hasDlpEnabled: boolean,
): NextgenSidebarSettings => {
	const { permissionInfo } = navData;
	// isAdmin is JiraAdmin here, not OrgAdmin or SiteAdmin
	// ref: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-plugins/jira-header-plugin/src/main/java/com/atlassian/jira/plugin/globalnav/sidebar/service/ProjectSidebarNavigationUtils.java#99
	const { isAdmin, projectPermissionsQueried } = permissionInfo;
	const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
	const isProjectAdminOrJiraAdmin = isAdmin || isProjectAdmin;
	const { hasExplicitFieldAssociationsEnabled = false } = navData;

	return {
		shouldShowDetailsMenu: isProjectAdminOrJiraAdmin,
		shouldShowAccessMenu: isProjectAdminOrJiraAdmin,
		shouldShowNotificationMenu: isProjectAdminOrJiraAdmin,
		shouldShowAutomationMenu: isProjectAdminOrJiraAdmin,
		shouldShowFieldsMenu: isProjectAdminOrJiraAdmin && hasExplicitFieldAssociationsEnabled,
		shouldShowIssueTypesMenu: isProjectAdminOrJiraAdmin,
		shouldShowFeaturesMenu: isProjectAdminOrJiraAdmin,
		shouldShowBoardsMenu: features.hasBoard && isProjectAdminOrJiraAdmin,
		shouldShowProformaFormsMenu: isProjectAdminOrJiraAdmin,
		shouldShowToolchainMenu: isProjectAdminOrJiraAdmin,
		shouldShowEcosystemAppMenu: isProjectAdminOrJiraAdmin,
		shouldShowDlpMenu: hasDlpEnabled && isProjectAdminOrJiraAdmin,
	};
};
